import { ChangeEventHandler } from 'react';

import { addStyles } from '../../utils/helpers';
import { Checkbox, CheckboxProps } from '../checkbox/checkbox';

export interface CheckboxGroupProps {
  /** The checkboxes to render */
  data: CheckboxProps[];
  /** The orientation of the group */
  layout?: 'horizontal' | 'vertical';
  /** The onChange handler */
  onChange?: ChangeEventHandler<HTMLInputElement>;
  /** The label for the group */
  label?: string;
}

const options = {
  layout: {
    vertical: 'flex flex-col space-y-4',
    horizontal: 'flex flex-row gap-x-8',
  },
};

export function CheckboxGroup({ layout = 'vertical', ...props }: CheckboxGroupProps) {
  const { data, label, onChange } = props;

  return (
    <fieldset className="checkbox-group">
      {label && <legend className="body-l mb-4">{label}</legend>}
      <div className={addStyles([options.layout[layout]])}>
        {data.map((checkboxProps, index) => {
          return <Checkbox key={index} {...checkboxProps} onChange={onChange} />;
        })}
      </div>
    </fieldset>
  );
}

export default CheckboxGroup;
